import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { nbfcLoginFailure, nbfcLoginSuccess } from "../actions/nbfcLoginAction";

function* asyncSubmitNbfcLoginRequestSaga(action){

    try{
    yield put(clearErrors());
    let loginResult = yield call(_api.submitNbfcLoginRequest,{
        loginReq: action.payload.loginReq
    })
     yield put(nbfcLoginSuccess({loginResult}));
    }catch(e){
        yield put(nbfcLoginFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* submitNbfcLoginRequestSaga(){
    yield takeLatest(types.NBFC_LOGIN_REQUEST,asyncSubmitNbfcLoginRequestSaga)
}